import React from 'react';

const PersonalDetailsStep = ({ data, onChange }) => {
  const handleChange = (field, value) => {
    if (field.includes('.')) {
      // Handle nested fields like address.city
      const [parent, child] = field.split('.');
      onChange({
        ...data,
        [parent]: {
          ...data[parent],
          [child]: value,
        },
      });
    } else {
      onChange({
        ...data,
        [field]: value,
      });
    }
  };

  const handlePhoneChange = (field, value) => {
    // Only allow digits and common phone formatting characters
    const cleaned = value.replace(/[^\d+\-\s()]/g, '');
    handleChange(field, cleaned);
  };

  const handlePincodeChange = (value) => {
    // Only allow digits, max 6 characters
    const cleaned = value.replace(/\D/g, '').slice(0, 6);
    handleChange('address.pincode', cleaned);
  };

  return (
    <div className="onboarding-step">
      <div className="step-header">
        <h2>Personal Details</h2>
        <p>Tell us about yourself and your contact information</p>
      </div>

      <div className="form-grid">
        <div className="form-group full-width">
          <label>Full Name *</label>
          <input
            type="text"
            value={data.fullName || ''}
            onChange={(e) => handleChange('fullName', e.target.value)}
            placeholder="Enter your full name"
            minLength="2"
            maxLength="100"
            required
          />
        </div>

        <div className="form-group">
          <label>Phone Number *</label>
          <input
            type="tel"
            value={data.phone || ''}
            onChange={(e) => handlePhoneChange('phone', e.target.value)}
            placeholder="+91 98765 43210"
            pattern="[6-9]\d{9}"
            title="Please enter a valid 10-digit Indian mobile number starting with 6-9"
            required
          />
          <small style={{ color: '#888', fontSize: '12px' }}>Enter 10-digit mobile number</small>
        </div>

        <div className="form-group">
          <label>Emergency Contact</label>
          <input
            type="tel"
            value={data.emergencyContact || ''}
            onChange={(e) => handlePhoneChange('emergencyContact', e.target.value)}
            placeholder="+91 98765 43210"
          />
        </div>

        <div className="form-group full-width">
          <label>Street Address *</label>
          <input
            type="text"
            value={data.address?.street || ''}
            onChange={(e) => handleChange('address.street', e.target.value)}
            placeholder="Enter street address"
            minLength="5"
            required
          />
        </div>

        <div className="form-group">
          <label>City *</label>
          <input
            type="text"
            value={data.address?.city || ''}
            onChange={(e) => handleChange('address.city', e.target.value)}
            placeholder="Enter city"
            required
          />
        </div>

        <div className="form-group">
          <label>State *</label>
          <input
            type="text"
            value={data.address?.state || ''}
            onChange={(e) => handleChange('address.state', e.target.value)}
            placeholder="Enter state"
            required
          />
        </div>

        <div className="form-group">
          <label>Pincode *</label>
          <input
            type="text"
            value={data.address?.pincode || ''}
            onChange={(e) => handlePincodeChange(e.target.value)}
            placeholder="400001"
            pattern="\d{6}"
            maxLength="6"
            title="Please enter a valid 6-digit pincode"
            required
          />
          <small style={{ color: '#888', fontSize: '12px' }}>6-digit Indian pincode</small>
        </div>

        <div className="form-group">
          <label>Profile Photo URL</label>
          <input
            type="url"
            value={data.photoURL || ''}
            onChange={(e) => handleChange('photoURL', e.target.value)}
            placeholder="https://example.com/photo.jpg"
          />
          <small>Optional: Photo for franchise ID card</small>
        </div>
      </div>
    </div>
  );
};

export default PersonalDetailsStep;

